import API from './Api'

const endpointBaseUrl = 'payserapayment';

class PayseraPaymentService {
    baseUrl(){
        return endpointBaseUrl;
    }

    createPayment(amount, email) {
        var data = {"cartTotal": amount, "email": email};
        var datastring = JSON.stringify(data);
        return API.get(endpointBaseUrl + "/geturl?d=" + btoa(datastring));
    }

    acceptPayment(paymentId) {
        return API.get(endpointBaseUrl + "/acceptpayment/" + paymentId);
    }

    cancelPayment(paymentId) {
        return API.get(endpointBaseUrl + "/cancelpayment/" + paymentId);
    }

    getPaymentStatus(paymentId) {
        return API.get(endpointBaseUrl + "/getpaymentstatus/" + paymentId);
    }
}

export default new PayseraPaymentService();